import { OpDayService, OpDayProvider, HttpService } from '@lk/api'

export const makeOpDayService = (http: HttpService, baseUrl: string) =>
  new OpDayService(new OpDayProvider(http, baseUrl))
